export const getImc = (weight, height) => 10000 * (weight / (height * height))
export const getRcq = (waistCircumference, hipCircumference) => {
  return waistCircumference / hipCircumference
}
export const getHdlC = (totalCholesterol, hdlCholesterol) => totalCholesterol - hdlCholesterol
export const getIfIsHypertensive = (
  systBloodPressure,
  diastBloodPressure
) => {

  if (!systBloodPressure || !diastBloodPressure) return false

  const hypertensiveByNumbers = systBloodPressure >= 140 || diastBloodPressure >= 90

  if (hypertensiveByNumbers) return true

  return false
}

export const getIfIsDiabetic = (glucose) => {
  return (glucose && glucose >= 100)
}
export const getIfIsDyslipidemic = (
  totalCholesterol,
  hdlCholesterol,
  triglycerides,
  ldlCholesterol
) => {
  if (totalCholesterol === 0 || totalCholesterol === '0' || totalCholesterol === null || totalCholesterol === '') {
    return ''
  }
  if (totalCholesterol) {
    return (
      totalCholesterol > 190
      || (triglycerides && triglycerides > 150)
      || (ldlCholesterol && ldlCholesterol > 130)
      || (hdlCholesterol && hdlCholesterol < 40)
    )
  }
  return false
}

export function getBodyWater(leanMassKg, totalWeight) {
  const lean = parseFloat(leanMassKg)
  const weight = parseFloat(totalWeight)

  if (!lean || !weight) return 0

  const waterKg = lean * 0.732
  const waterPercentage = (waterKg / weight) * 100

  return waterPercentage.toFixed(1)
}

/**
 * Massa Óssea (kg)
 */
export function getBoneMassEstimative(leanMassKg) {
  const lean = parseFloat(leanMassKg)
  if (!lean) return 0

  const boneMass = lean * 0.040
  return boneMass.toFixed(1)
}

/**
 * Proteína (%)
 */
export function getProtein(leanMassKg, totalWeight) {
  const lean = parseFloat(leanMassKg)
  const weight = parseFloat(totalWeight)

  if (!lean || !weight) return 0

  const waterKg = lean * 0.732
  const boneKg = lean * 0.039

  const proteinKg = lean - waterKg - boneKg
  const proteinPercentage = (proteinKg / weight) * 100

  return proteinPercentage.toFixed(1)
}

/**
 * Peso Ideal (IMC 22)
 */
export function getIdealWeight(heightCm) {
  const h = parseFloat(heightCm) / 100
  if (!h) return 0

  const ideal = 22 * (h * h)
  return ideal.toFixed(1)
}
